import { memo, useCallback } from 'react';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import UICurrencyInput from 'UIComponents/input/UICurrencyInput';
import { getCurrencyCodeForPriceProperty } from 'customer-data-objects/lineItem/PropertyNames';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { parseNumericValue } from '../utils/parseNumericValue';
import isFractionalCurrencySupported from '../v2/utils/isFractionalCurrencySupported';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputPrice = props => {
  const {
    onChange,
    inputRef,
    property,
    currencyCode: passedCurrencyCode,
    value,
    min = 0,
    objectTypeId
  } = props;
  const handleChange = useCallback(evt => {
    const {
      target: {
        value: newValue
      }
    } = evt;
    if (typeof onChange === 'function') {
      // UICurrencyInput's onChange sends `number | null`; convert to `string | null`
      onChange(newValue == null ? evt : SyntheticEvent(String(newValue)));
    }
  }, [onChange]);
  const currencyCode = passedCurrencyCode || getCurrencyCodeForPriceProperty(property.name) || '';
  const currencyValue = parseNumericValue(value);
  const defaultFractionalCurrencyProps = {
    maxFractionDigits: 6
  };
  const fractionalCurrencyProps = isFractionalCurrencySupported(objectTypeId) ? defaultFractionalCurrencyProps : undefined;
  return /*#__PURE__*/_jsx(UICurrencyInput, Object.assign({}, getTransferrableProps(props), fractionalCurrencyProps, {
    min: min,
    currency: currencyCode,
    onChange: handleChange,
    inputRef: inputRef
    // @ts-expect-error UICurrencyInput propTypes allow 'null', but TS types do not; see https://git.hubteam.com/HubSpot/UIComponents/issues/10822
    ,
    value: currencyValue
  }));
};
export default /*#__PURE__*/memo(PropertyInputPrice);